import React, {memo, Suspense} from "react"
import {formatTextTestIds} from "@next/utils"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type MenuItemCountryFlagImgProps = {
    alt: string
    src: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const MenuItemCountryFlagImg = memo(({alt, src, templating}: MenuItemCountryFlagImgProps) => {
    const TemplatedComponent = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <TemplatedComponent alt={alt} src={src} data-testid={formatTextTestIds("header-country-lang-flag")} />
        </Suspense>
    )
})
MenuItemCountryFlagImg.displayName = "MenuItemCountryFlagImg"

export default connect(MenuItemCountryFlagImg)
